import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Subscription } from 'rxjs';

import { coreActions } from './modules/core/store/core.actions';
import { LoadingPanelService } from './modules/loading-panel/loading-panel.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnDestroy {

  private isLoading$$ = new BehaviorSubject<boolean>(false);
  isLoading$ = this.isLoading$$.asObservable();

  private subs = new Subscription();

  constructor(
    private store: Store,
    private loadingPanelSvc: LoadingPanelService
  ) { }

  ngOnInit() {
    this.subs.add(
      this.loadingPanelSvc.isLoading$.subscribe(x => {
        this.isLoading$$.next(x);
      })
    );
    this.subs.add(
      this.isLoading$.subscribe()
    );

    this.store.dispatch(coreActions.loadState());
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
